import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "routes";
import NotFound from "views/errors/404";
import AtriumLogo from "layouts/auth/AtriumLogo";

export default function Member() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/member") {
        return (
          <Route path={`${prop.path}`} element={prop.component} key={key} />
        );
      }

      return null;
    });
  };
  document.documentElement.dir = "ltr";

  return (
    <div className="min-h-screen w-full bg-canvas font-dm text-fg">
      <div className="mx-auto flex min-h-screen w-full flex-col px-4 pb-10 sm:max-w-[390px]">
        <header className="pt-6">
          <AtriumLogo />
        </header>
        <main className="flex flex-1 flex-col">
          <Routes>
            {getRoutes(routes)}
            <Route
              path="/"
              element={<Navigate to="/volunteer/my-services" replace />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
